// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"24463d28","160":"653c18ba","208":"010fb3eb","293":"3a509ef0","516":"2d961c53","519":"c74c8aa2","917":"a651e7df","946":"b97c1564"}[chunkId] + ".chunk.js";
};